<template>
    <div class="container">
        <div class="main__top">
            <h1 class="main__title wow fadeInDown" data-wow-duration="1.5s">Book Now</h1>
        </div>

        <div class="artist" v-if="artist">
            <div class="row justify-content-center">
                <div class="col-lg-8">
                    <div class="artist__content wow fadeInUp" data-wow-duration="1.5s">
                        <div class="artist__info">
                            <div class="artist__book">
                                <img
                                    :src="getNameOfAvatar(artist.file_avatar.file_path)"
                                    alt="Photo"
                                    class="img"
                                    width="110"
                                    height="130"
                                >
                                <div class="inner">
                                    <h2 class="title m-0"><strong>{{artist.stage_name}}</strong></h2>
                                    <p
                                        v-for="category in artist.categories"
                                        :key="category.id"
                                    >
                                        {{ category.name }}
                                    </p>

                                </div>
                                <a :href="`/client/artist/${artistId}`"  class="btn btn_primary-outline">View</a>
                            </div>
                        </div>
                        <ValidationObserver ref="form">
                            <div class="form">
                                <div class="row">

                                    <ValidationProvider
                                        class="col-sm-6"
                                        name="First Name"
                                        v-slot="{ errors }"
                                        rules="required"
                                    >
                                        <div class="form-group">
                                            <input
                                                type="text"
                                                class="form-control"
                                                placeholder="First Name*"
                                                v-model="form.first_name"
                                            >
                                            <FormError :error="errors[0]"  name="First Name"></FormError>
                                            <span class="form-icon">
                                                <svg width="20" height="20" aria-hidden="true">
                                                    <use href="/img/svg/symbol-defs.svg#icon-user"></use>
                                                </svg>
                                            </span>
                                        </div>
                                    </ValidationProvider>

                                    <ValidationProvider
                                        class="col-sm-6"
                                        name="Last Name"
                                        v-slot="{ errors }"
                                        rules="required"
                                    >
                                        <div class="form-group">
                                            <input
                                                type="text"
                                                class="form-control"
                                                placeholder="Last Name*"
                                                v-model="form.last_name"
                                            >
                                            <FormError :error="errors[0]"  name="Last Name"></FormError>
                                            <span class="form-icon">
                                                <svg width="20" height="20" aria-hidden="true">
                                                    <use href="/img/svg/symbol-defs.svg#icon-user"></use>
                                                </svg>
                                            </span>
                                        </div>
                                    </ValidationProvider>

                                    <ValidationProvider
                                        class="col-sm-6"
                                        name="Email"
                                        v-slot="{ errors }"
                                        rules="required|email"
                                    >
                                        <div class="form-group">
                                            <input
                                                type="email"
                                                class="form-control"
                                                placeholder="Email*"
                                                v-model="form.email"
                                            >
                                            <FormError :error="errors[0]"  name="Email"></FormError>
                                            <span class="form-icon">
                                                <svg width="20" height="20" aria-hidden="true">
                                                    <use href="/img/svg/symbol-defs.svg#icon-envelope"></use>
                                                </svg>
                                            </span>
                                        </div>
                                    </ValidationProvider>

                                    <ValidationProvider
                                        class="col-sm-6"
                                        name="Phone"
                                        v-slot="{ errors }"
                                        rules="required"
                                    >
                                        <div class="form-group">
                                            <input
                                                type="tel"
                                                class="form-control"
                                                v-mask="'+1 (###) ###-####'"
                                                v-model="form.phone"
                                            >
                                            <FormError :error="errors[0]"  name="Email"></FormError>
                                            <span class="form-icon">
                                                <svg width="20" height="20" aria-hidden="true">
                                                    <use href="/img/svg/symbol-defs.svg#icon-telephone"></use>
                                                </svg>
                                            </span>
                                        </div>
                                    </ValidationProvider>

                                    <ValidationProvider
                                        class="col-12"
                                        name="Message"
                                        v-slot="{ errors }"
                                        rules="required"
                                    >
                                        <div class="form-group">
                                            <textarea
                                                class="form-control"
                                                placeholder="Type your message here*"
                                                v-model="form.message"
                                            ></textarea>
                                            <FormError :error="errors[0]"  name="Message"></FormError>
                                            <span class="form-icon">
                                                <svg width="20" height="20" aria-hidden="true">
                                                    <use href="/img/svg/symbol-defs.svg#icon-pen"></use>
                                                </svg>
                                            </span>
                                        </div>
                                    </ValidationProvider>
                                    <div class="col-sm-4">
                                        <div class="form-group text-right">
                                            <button
                                                type="submit"
                                                class="btn btn_golden"
                                                @click="validateForm"
                                            >
                                                <span class="pl-5 pr-5">Submit</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import FormError from "../Common/FormError.vue";
import {mapActions, mapState} from "pinia";
import {useClientStore} from "../../stores/ClientStore";
import ClientService from "../../services/ClientService";

export default {
    name: 'BookArtistRequest',
    components: {FormError},
    props: {
        artistId: {
           type: String | Number
        }
    },
    computed:{
        ...mapState(useClientStore, {
            artist: 'artistInfo'
        })
    },
    data() {
        return {
            form: {
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
                message: null,
            }
        }
    }, mounted() {
        this.fetchArtist(this.artistId)
    },
    methods: {
        getNameOfAvatar(photo) {
            return photo ? `/uploads/${photo}` : "/img/svg/avatar.svg";
        },
        ...mapActions(useClientStore, {
            fetchArtist: 'fetchArtist'
        }),
        async validateForm() {
            this.$showLoadingMessage()
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorMessage();
                return;
            }
            await this.sendForm()
        },
        async sendForm() {
            try {
                await ClientService.sendArtistBookingRequest(this.artistId)
            } catch {

            }
        }
    }

}

</script>



<style scoped>

</style>
